// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","HomeBaseBanner":"tk_a bik_b bik_bj","HomeBaseBanner__hint":"tk_b bik_vh","HomeBaseBanner__link":"tk_c"};